import { API_URL } from './apiUrl';

export async function openBillingPortal({ email, uid }) {
  if (!email && !uid) {
    throw new Error('You must be signed in to manage billing.');
  }

  const response = await fetch(`${API_URL}/create-billing-portal-session`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, uid }),
  });

  const data = await response.json();
  if (!response.ok || !data.url) {
    throw new Error(data.error || data.message || 'Failed to open billing portal');
  }

  window.open(data.url, '_blank', 'noopener,noreferrer');
}
